function socialMediaLinkAccountDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-link-account/social-media-link-account.html?$$REVISION$$'
  }
}

export { socialMediaLinkAccountDialog }
